import React, { FunctionComponent, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { hideHeaderFlashMessage } from '@client/redux/modules/flashMessage/actions';
import { getHeaderFlashMessage } from '@client/redux/modules/flashMessage/selectors';
import FlashMessageContent from '@client/components/shared/flashMessage/FlashMessageContent';

import styles from './styles.scss';

const FADE_DURATION_MS = 300; // ms
const HIDE_TIMER_MS = 5000; // ms

export const FlashMessages: FunctionComponent<{}> = () => {
    let timer: number = null;
    const dispatch = useDispatch();

    const { type, text, customIcon } = useSelector(getHeaderFlashMessage);

    useEffect(() => {
        if (!type || !text) {
            return;
        }

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(
            () => dispatch(hideHeaderFlashMessage()),
            HIDE_TIMER_MS
        );

        return () => {
            clearTimeout(timer);
        };
    }, [type, text]);

    return (
        <TransitionGroup>

            {type && text && (
                 <CSSTransition
                    component="div"
                    classNames={styles}
                    timeout={{enter: FADE_DURATION_MS, exit: FADE_DURATION_MS}}
                >
                    <div styleName="wrapper">
                        <FlashMessageContent
                            type={type}
                            text={text}
                            customIcon={customIcon}
                        />
                    </div>
                </CSSTransition>
            )}
        </TransitionGroup>
    );
};

export default CSSModules(styles)(FlashMessages);
